import React from "react";
import { AccountStatus } from "@common/types/domains/accounting/account";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const accountStatuses: string[] = Object.values(AccountStatus);

function isAccountStatus(
    value: FilterMultiselectValue,
): value is AccountStatus {
    return typeof value === "string" && accountStatuses.includes(value);
}

const options: FilterMultiselectOption[] = [
    {
        value: AccountStatus.ENABLED,
        label: "Active",
        searchableLabel: "active",
    },
    {
        value: AccountStatus.DISABLED,
        label: "Archived",
        searchableLabel: "archived",
    },
];

export const AccountStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.accountStatus ? [filters.accountStatus] : [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    if (val.length === 0) {
                        onChange({ accountStatus: undefined });
                        return;
                    }
                    const added = val.find(
                        (v): v is AccountStatus =>
                            v !== filters.accountStatus && isAccountStatus(v),
                    );
                    const first = val[0];
                    const fallback = isAccountStatus(first) ? first : undefined;
                    onChange({ accountStatus: added ?? fallback });
                }}
                name="accountStatus"
                onBlur={noop}
            />
        </div>
    );
};
